import Amchart from './Amchart';

export default Amchart;
